module.exports = __webpack_public_path__ + "img/AF.fec1c77b.svg";